<template>
  <section
    id="form"
    class="mx-auto max-w-6xl pl-4 pr-4 py-20 text-center min-[1024px]:mt-[100px] min-[1024px]:mb-[200px]"
  >
    <h2 class="landing_h2 mb-2 text-center">
      <Translate translate-key="tradeline_brokerage_page.start_today" />
    </h2>
    <p class="mb-8 text-2xl font-black text-black md:text-3xl">
      <Translate translate-key="tradeline_brokerage_page.contact_us" />
    </p>
    <div class="flex justify-center">
      <Button
        as="a"
        :href="linkHref(signupPath)"
        variant="landing1"
        size="xl"
      >
        <Translate translate-key="tradeline_brokerage_page.get_started_now" />
      </Button>
    </div>
  </section>
</template>

<script setup lang="ts">
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import { Button } from "~/shared/components/ui/button";

withDefaults(
  defineProps<{
    /** Signup path (default broker signup) */
    signupPath?: string;
  }>(),
  { signupPath: "/signup?type=broker" },
);

const { linkHref } = useNativeRouteLink();
</script>
